import React from "react"
import MetaTags from "react-meta-tags"
import { withRouter } from "react-router-dom"
import {
  Container,
} from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

import ExperienceListTable from "./ExperienceListTable"
import "../../../../assets/scss/custom.scss"

const ExperienceList = props => {
  return (
    <>
      {
        <React.Fragment>
          <div className="page-content">
            <MetaTags>
              <title>Experience | EEFind </title>
            </MetaTags>
            <Container fluid>
              <Breadcrumbs title="Experience" breadcrumbItem="Experience List" />
              <ExperienceListTable
                queryCondition={null}
                activeFilters={null}
                filterQueryConditions={null}
                showCreateBtn={true}
              />
            </Container>
          </div>
        </React.Fragment>
      }
    </>
  )
}
ExperienceList.propTypes = {}
export default withRouter(ExperienceList)
